<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormPedidoFisico" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
							<BuscadorCliente 
								ref="buscadorCliente"
								:ptextLabel="'Buscar Cliente'"
								@input="getCliente()"
								v-model="objCliente.IdCliente">
								<CValidation v-if="this.errorvalidacion.IdCliente" :Mensaje="'*' + errorvalidacion.IdCliente[0]"/>
							</BuscadorCliente>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
							<label class="form-label" for="ContactoCliente">Contacto</label>
							<input type="text" v-model="objCliente.Contacto" class="form-control" id="ContactoCliente" placeholder="" readonly />
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
							<label class="form-label" for="DireccionCliente">Dirección</label>
							<input type="text" v-model="objCliente.Direccion" class="form-control" id="DireccionCliente" placeholder="" readonly />
						</div>
					</div>

					<div class="form-group row mb-10">
						<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
							<label class="form-label" for="FolioFisico">Rfc</label>
							<input type="text" v-model="objCliente.Rfc" class="form-control" id="FolioFisico" placeholder="Ingresar Folio Fisico" readonly/>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
							<label class="form-label" for="FolioFisico">Folio</label>
							<input type="text" v-model="objPedidoFisico.FolioFisico" class="form-control" id="FolioFisico" placeholder="Ingresar Folio Fisico" />
							<CValidation v-if="this.errorvalidacion.FolioFisico" :Mensaje="'*'+errorvalidacion.FolioFisico[0]"/>
						</div>
						
						<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
							<label class="form-label" for="Fecha">Fecha</label>
							<div class="calendar">
								<input type="text" v-model="objPedidoFisico.Fecha" class="form-control" readonly>
							</div>
							<CValidation v-if="this.errorvalidacion.Fecha" :Mensaje="'*'+errorvalidacion.Fecha[0]"/>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>
import BuscadorCliente from '@/components/BuscadorCliente.vue';
import Calendar from '@/helpers/StaticComboBox.js';
import moment from 'moment';

export default {
    name: 'FormPedidoFisico',
    props: ['poBtnSave'],
    components:{
		BuscadorCliente
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objPedidoFisico: {
				IdPedidoFisico: 0,
				IdCliente: 0,
				FolioFisico: '',
				Fecha: moment(new Date()).format('YYYY-MM-DD'),
				Estatus: '',
				IdUserCreacion: 0,
				IdUserUploadFile: 0,
				Archivo: '',
				Observaciones: '',
            },
			objCliente: {},
			Setpicker:Calendar.calendarSettings,
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			let Fecha = '';

			if (this.objPedidoFisico.Fecha!='') {
				Fecha = moment(this.objPedidoFisico.Fecha).format('YYYY-MM-DD');
			}

			/* let file = this.$refs.fileArchivo.files[0];

			if(this.objPedidoFisico == 0 && file == undefined)
			{
				this.$toast.warning('Debe seleccionar un archivo');
				return true;
			} */

			let formData = new FormData();
			formData.set('IdPedidoFisico', this.objPedidoFisico.IdPedidoFisico);
			formData.set('IdCliente', this.objPedidoFisico.IdCliente);
			formData.set('FolioFisico', this.objPedidoFisico.FolioFisico);
			formData.set('Archivo', this.objPedidoFisico.Archivo);
			formData.set('Fecha', Fecha);
			formData.set('Estatus', this.objPedidoFisico.Estatus);
			formData.set('Observaciones', this.objPedidoFisico.Observaciones);
			// formData.append('Pdf', file);
			
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;
			
			await this.$http.post('pedidosFisicos', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_seccionFisica');
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "pedidosFisicos/"+this.objPedidoFisico.IdPedidoFisico
            ).then((res) => {
                this.objPedidoFisico = res.data.data;
				this.objCliente  = this.objPedidoFisico.cliente;
				this.setCliente(this.objCliente);

				// en caso de que necesite fecha
				let formatedDate1 = this.objPedidoFisico.Fecha.replace(/-/g,'\/');
                this.objPedidoFisico.Fecha = new Date(formatedDate1);
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objPedidoFisico = {
				IdPedidoFisico: 0,
				IdCliente: 0,
				FolioFisico: '',
				Archivo: '',
				Fecha: moment(new Date()).format('YYYY-MM-DD'),
				Estatus: '',
				IdUserCreacion: 0,
				IdUserUploadFile: 0,
				Observaciones: '',
				
            }
            this.errorvalidacion = [];
        },
		getCliente() {
            
            this.$http.get( `/clientes/${this.objCliente.IdCliente}` )
            .then( res => {
                const cliente = res.data.data;
                this.objCliente = cliente;
				this.objPedidoFisico.IdCliente = this.objCliente.IdCliente;

            }).catch( err => {

            	this.limpiaCliente();
            });
        },
    	setCliente( cliente = {} ) {
			// console.log('SettingCliente');
        	const buscadorCliente = this.$refs.buscadorCliente;
            buscadorCliente.clientes.push({
                label: `${cliente.Nombre}`,
                detalle: {
                    clave: cliente.Clave,
					Rfc: cliente.Rfc,
                },
				key: cliente.IdCliente,
        	});
        },
		limpiaCliente(){
            this.objCliente = {
                NombreComercial: '',
                RazonSocial: '',
                Rfc: '',
                Contacto: '',
                Telefono: '',
                Correo: '',
                Direccion:'',
                Calle: '',
                NoInt: '',
                NoExt: '',
                Colonia: '',
                Cp: '',
                Cruzamiento1: '',
                Cruzamiento2: '',
                Referencias: '',
                IdEstado: '',
                IdMunicipio: '',
            }
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objPedidoFisico.IdPedidoFisico = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
